import { computed, makeObservable, observable } from "mobx";
import { observer } from "mobx-react";
import { Component } from "react";
import { type IntlShape, injectIntl } from "react-intl";
import { compose } from "nvent-web/utils/compose";

import { type DropdownOption } from "nvent-web/types/DropdownOption";
import { countryCodes } from "nvent-web/utils/countryCodes";
import { getCountryNameByCode } from "nvent-web/utils/getCountryNameByCode";

import { DropdownField } from "./DropdownField";
import { type DropdownFieldProps } from "./DropdownField";

type CountriesFieldProps = Omit<DropdownFieldProps, "options">;

interface CountriesFieldInnerProps extends CountriesFieldProps {
  intl: IntlShape;
}

class CountriesFieldInner extends Component<CountriesFieldInnerProps> {
  locale: string;

  constructor(props: CountriesFieldInnerProps) {
    super(props);

    this.locale = props.intl.locale;

    makeObservable(this, {
      locale: observable,
      countriesWithIsos: computed,
    });
  }

  componentDidUpdate(prevProps: CountriesFieldInnerProps) {
    if (prevProps.intl.locale !== this.props.intl.locale) {
      this.locale = this.props.intl.locale;
    }
  }

  get countriesWithIsos(): DropdownOption[] {
    return countryCodes.map((iso) => {
      return {
        key: iso,
        title: getCountryNameByCode(iso, this.locale),
      };
    });
  }

  render() {
    return <DropdownField options={this.countriesWithIsos} {...this.props} />;
  }
}

const CountriesField = compose<CountriesFieldProps>(
  injectIntl,
  observer
)(CountriesFieldInner);

export default CountriesField;
